import { ToastService } from "service/shared/others/ToastService/Toast.service";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = ToastService[];

export const useDefaultObservableToastServiceArray = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectToastServiceArray extends BehaviorSubject<CurrentType> {}
